import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import {
  NgxAuthOptions,
  OidcOptions,
  provideNgxAuth,
  withAuthTranslationLoader,
  withLogger,
  withTenantPersistence,
} from '@mds/ngx-auth';
import { API_BASE_URL, UnauthenticatedConfigService } from '@mds/ngx-core';
import { AppInsightsService } from '@mds/ngx-diagnostics';
import { filter, first, map } from 'rxjs';
import { ConfigResponse } from '../shared';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideNgxAuth(
      ngxAuthOptionsFactory,
      withLogger(),
      withTenantPersistence(),
      withAuthTranslationLoader(),
    ),
  ]);
}

function ngxAuthOptionsFactory(): NgxAuthOptions {
  const appInsightsService = inject(AppInsightsService);
  const baseUrl = inject(API_BASE_URL);
  const configService = inject(UnauthenticatedConfigService<ConfigResponse>);

  return {
    appId: 'rpl',
    oidc$: configService.config$.pipe(
      filter((x): x is ConfigResponse => !!x),
      first(),
      map<ConfigResponse, OidcOptions>(
        (c) =>
          ({
            clientId: c.auth.clientId,
            authority: c.auth.issuer,
            redirectUrl: c.auth.redirectUri,
            postLogoutRedirectUrl: c.auth.postLogoutRedirectUrl,
            audience: c.auth.resource,
            secureRoutes: [c.auth.resource, baseUrl],
            renewTimeBeforeTokenExpiresInSeconds: 900,
          }) satisfies OidcOptions,
      ),
    ),
    tenancy: {
      hasBranches: true,
    },
    apiBaseAddress: baseUrl,
    unauthenticatedUrl: 'error/401',
    unauthorizedUrl: 'error/403',
    logger: appInsightsService,
    headerMenuConfig: {
      showLanguageSwitch: true,
      showThemeSwitch: false,
      showBranchSwitch: true,
    },
  };
}
